import * as RadixCheckbox from '@radix-ui/react-checkbox'
import { CheckIcon } from 'flyt/ui/Icons/Icons'
import type { CheckboxProps } from './Checkbox.types'

/**
 * checkbox — controlled on/off toggle primitive.
 *
 * Holds no checked state of its own: the display mirrors the `checked` prop
 * and every interaction reports the intended next value once, coerced to a
 * strict boolean (the library's indeterminate value becomes false). Any prop
 * beyond the value/change pair (the accessible label, the disabled state) is
 * forwarded unchanged. @radix-ui/react-checkbox is confined to this unit.
 */
export function Checkbox({ checked, onCheckedChange, ...rest }: CheckboxProps) {
  return (
    <RadixCheckbox.Root
      {...rest}
      checked={checked}
      onCheckedChange={(value) => onCheckedChange(value === true)}
      className="flex size-4 shrink-0 items-center justify-center rounded-sm border border-border-control bg-surface data-[state=checked]:border-accent data-[state=checked]:bg-accent data-[state=checked]:text-accent-contrast data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50"
    >
      <RadixCheckbox.Indicator className="flex items-center justify-center">
        <CheckIcon width={12} height={12} />
      </RadixCheckbox.Indicator>
    </RadixCheckbox.Root>
  )
}
